import styled from 'styled-components';
import { getTypographyStyles, SYS_SPACE_FIXED_300, SYS_SPACE_FIXED_200, SYS_SPACE_FIXED_100, getMargins, SYS_BORDER_RADIUS_MD, SYS_BREAKPOINT_MD, SEM_TYPOGRAPHY_UI_MD_CAPTION, SYS_BREAKPOINT_SM, SYS_BREAKPOINT_LG, SYS_BREAKPOINT_XL } from '@oneaudi/unified-web-alpha-common';
import {} from './index.js';
import { Headline } from '../headline/index.js';
const getSlideWidth = (ratio, size, layout) => {
    if (layout === 'flexible') {
        const widths = {
            xs: '280px',
            sm: '320px',
            md: ratio === '1:1' ? '568px' : '600px',
            lg: ratio === '1:1' ? '384px' : '800px',
            xl: ratio === '1:1' ? '560px' : '1000px'
        };
        return widths[size];
    }
    const widths = {
        xs: '280px',
        sm: '320px',
        md: '320px',
        lg: '320px',
        xl: '320px'
    };
    return widths[size];
};
export const StyledCarousel = styled.div `
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-start;
  margin: ${(props) => getMargins(props.margin)};
`;
export const StyledSlideContainer = styled.ul `
  padding: 0 var(--page-margin);
  margin: 0;
  list-style-type: none;
  display: flex;
  overflow: auto;
  align-self: flex-start;
  scroll-behavior: smooth;
  width: 100%;
  box-sizing: border-box;

  &::-webkit-scrollbar {
    display: none;
  }

  scrollbar-width: none;
  -ms-overflow-style: none;
`;
export const StyledSlide = styled.li `
  flex: 0 0 ${(props) => getSlideWidth(props.aspectRatio, 'xs', props.layout)};
  border-radius: ${SYS_BORDER_RADIUS_MD};
  padding-bottom: ${SYS_SPACE_FIXED_200};
  outline-offset: -2px;

  &:not(:last-child) {
    margin-right: ${SYS_SPACE_FIXED_200};
  }

  @media (min-width: ${SYS_BREAKPOINT_SM}) {
    flex-basis: ${(props) => getSlideWidth(props.aspectRatio, 'sm', props.layout)};
  }

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    flex-basis: ${(props) => getSlideWidth(props.aspectRatio, 'md', props.layout)};
  }

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    flex-basis: ${(props) => getSlideWidth(props.aspectRatio, 'lg', props.layout)};
  }

  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    flex-basis: ${(props) => getSlideWidth(props.aspectRatio, 'xl', props.layout)};
  }
`;
export const StyledImage = styled.img `
  display: block;
  aspect-ratio: 1;
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    aspect-ratio: ${(props) => (props.aspectRatio === '1:1' ? '1' : '16/9')};
  }
  border-radius: ${SYS_BORDER_RADIUS_MD};
  object-fit: cover;
  width: 100%;
`;
export const StyledControlPanel = styled.div `
  box-sizing: border-box;
  display: flex;
  padding-top: ${SYS_SPACE_FIXED_200};
  gap: ${SYS_SPACE_FIXED_200};
  justify-content: flex-end;
  align-self: flex-end;
  margin-right: var(--page-margin);
`;
export const StyledTextSlide = styled.div `
  margin-top: ${SYS_SPACE_FIXED_300};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
export const StyledDisclaimer = styled.span `
  ${getTypographyStyles(SEM_TYPOGRAPHY_UI_MD_CAPTION)};
  color: ${(props) => props.theme.sys.color.text.caption.default};

  &:not(:first-child) {
    margin-top: ${SYS_SPACE_FIXED_200};
  }
`;
export const StyledCustomSlot = styled.div `
  &:not(:first-child) {
    margin-top: ${SYS_SPACE_FIXED_200};
  }
  align-self: normal;
`;
export const StyledHeadline = styled(Headline) `
  &:not(:last-child) {
    margin-bottom: ${SYS_SPACE_FIXED_100};
  }
`;
//# sourceMappingURL=index.styles.js.map